import api from '../services/api';

const TourPublicModel = {
    // Obtener todos los tours disponibles
    getAll: async () => {
        try {
            const response = await api.get('/tours');
            return response.data;
        } catch (error) {
            console.error('Error obteniendo tours:', error);
            return [];
        }
    },

    // Crear una reservación de tour
    create: async (tourData) => {
        try {
            const response = await api.post('/tours', tourData);
            return response.data;
        } catch (error) {
            console.error('Error creando reservación:', error);
            throw error;
        }
    }
};

export default TourPublicModel;